/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Kind_ProductInputs */

const vi_stocktake_kind_product = /** @type {(inputs: Stocktake_Kind_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm`)
};

/**

* @param {Stocktake_Kind_ProductInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_kind_product = /** @type {((inputs?: Stocktake_Kind_ProductInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Kind_ProductInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_kind_product(inputs)
});